import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const services = [
    {
        icon: "business_center",
        title: "Corporate Transportation",
        description:
            "Reliable transportation solutions for meetings, conferences, executive travel, and corporate events.",
    },
    {
        icon: "flight",
        title: "Airport Transfers",
        description:
            "Professional airport transportation with punctual pickups and stress-free travel experiences.",
    },
    {
        icon: "groups",
        title: "Group Travel",
        description:
            "Comfortable transportation for private groups, tours, family gatherings, and organizations.",
    },
    {
        icon: "celebration",
        title: "Event Transportation",
        description:
            "Transportation services for weddings, concerts, sporting events, and special occasions.",
    },
    {
        icon: "directions_bus",
        title: "Employee Shuttles",
        description:
            "Customized employee transportation solutions designed for convenience and efficiency.",
    },
    {
        icon: "school",
        title: "School Transportation",
        description:
            "Safe and dependable transportation for schools, colleges, and educational programs.",
    },
];

const benefits = [
    {
        icon: "verified_user",
        title: "Safety First",
    },
    {
        icon: "schedule",
        title: "On-Time Service",
    },
    {
        icon: "support_agent",
        title: "24/7 Support",
    },
    {
        icon: "workspace_premium",
        title: "Premium Experience",
    },
];

export const Services = () => {
    return (
        <section className="bg-primary">
            <Helmet>
                <title>Services | Corporate, Airport & Group Travel | Velox Charter</title>

                <meta
                    name="description"
                    content="Explore Velox Charter's professional transportation services, including corporate transportation, airport transfers, employee shuttles, group travel, school transportation, and event transportation. Safe, reliable, and tailored transportation solutions across the USA."
                />
            </Helmet>
            
            <div className="max-w-7xl mx-auto px-4">
                <div className="h-[220px] md:h-[280px] flex items-center justify-center">
                    <h1 className="text-white text-4xl md:text-6xl font-bold text-center">
                        Our Services
                    </h1>
                </div>
            </div>

            <section className="bg-[#F9FAFB] py-16 md:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    <div className="text-center">
                        <h2 className="text-4xl md:text-5xl font-semibold text-black">
                            Transportation Solutions Tailored To Your Needs
                        </h2>

                        <p className="mt-6 max-w-3xl mx-auto text-gray-500 text-base md:text-lg leading-relaxed">
                            At Velox Charter, we provide dependable transportation services
                            designed to deliver comfort, reliability, and peace of mind.
                            Whether you're arranging executive travel, airport transfers,
                            employee transportation, or private group travel, our team is
                            committed to providing a seamless experience.
                        </p>
                    </div>

                    <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {services.map((service, index) => (
                            <div
                                key={index}
                                className="
                                    bg-white
                                    border border-[#D0D0D0]
                                    rounded-[20px]
                                    p-8
                                    hover:shadow-xl
                                    transition-all
                                    duration-300
                                    hover:-translate-y-1
                                "
                            >
                                <span className="material-symbols-outlined text-[40px] text-secondryBlue">
                                    {service.icon}
                                </span>

                                <h3 className="mt-6 text-xl font-semibold text-secondryBlue">
                                    {service.title}
                                </h3>

                                <p className="mt-4 text-gray-500 leading-7">
                                    {service.description}
                                </p>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            <section className="bg-[#F5F5F5] py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">

                        <div>
                            <img
                                src="/images/veloxcharter-services.png"
                                alt="Transportation Services"
                                className="
                                    w-full
                                    h-[300px]
                                    md:h-[500px]
                                    rounded-[30px]
                                "
                            />
                        </div>

                        <div>
                            <h2 className="text-[36px] md:text-[52px] font-semibold leading-tight">
                                Customized Transportation Solutions
                            </h2>

                            <div className="mt-6 space-y-5 text-[#666666] leading-8 text-base md:text-lg">

                                <p>
                                    Every trip has unique requirements, which is why
                                    we create transportation solutions tailored to
                                    your schedule, passenger count, and destination.
                                </p>

                                <p>
                                    From corporate events and airport transportation
                                    to employee shuttles and private group travel,
                                    our team works closely with clients to ensure
                                    every detail is handled professionally.
                                </p>

                                <p>
                                    Our goal is to deliver a comfortable, efficient,
                                    and worry-free transportation experience from
                                    departure to destination.
                                </p>

                            </div>
                        </div>

                    </div>

                </div>
            </section>

            <section className="bg-white py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4">

                    <div className="text-center">
                        <h2 className="text-4xl md:text-5xl font-semibold">
                            Why Choose Velox Charter
                        </h2>

                        <p className="mt-6 max-w-3xl mx-auto text-gray-500">
                            We combine safety, reliability, and exceptional customer
                            service to deliver transportation experiences that exceed
                            expectations.
                        </p>
                    </div>

                    <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-6">

                        {benefits.map((item, index) => (
                            <div
                                key={index}
                                className="
                                    bg-[#F8FAFC]
                                    rounded-[20px]
                                    p-8
                                    text-center
                                    border
                                "
                            >
                                <span className="material-symbols-outlined text-[40px] text-secondryBlue">
                                    {item.icon}
                                </span>

                                <h3 className="mt-4 font-semibold text-lg">
                                    {item.title}
                                </h3>
                            </div>
                        ))}

                    </div>
                </div>
            </section>

            <section className="bg-primary py-20">
                <div className="max-w-5xl mx-auto px-4 text-center">

                    <h2 className="text-white text-4xl md:text-5xl font-semibold">
                        Ready To Plan Your Next Trip?
                    </h2>

                    <p className="mt-6 text-white/80 text-lg">
                        Experience reliable, comfortable, and professional
                        transportation services with Velox Charter.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
                        <Link
                            to="/contact-us"
                            className="
        inline-block
        bg-white
        text-primary
        px-8
        py-4
        rounded-full
        font-semibold
        hover:scale-105
        transition-all
    "
                        >
                            Contact Us
                        </Link>
                    </div>
                </div>
            </section>

        </section>
    );
};